import React from "react";
import "./_header.scss";
export default function HeaderBar() {
  return <div className={"header-bar"} />;
}
